import { useData } from "../contexts/DataContext";

function NotFound() {
  const { state } = useData();
  return (
    <div style={{ textAlign: "center", marginBottom: "10px" }}>
      <h2>404 Page Not Found</h2>
      <p>Sorry, the page you're looking for does not exist.</p>
      <img
        src={
          state.globalData
            ? `${state.baseApiPath}${state.globalData?.PageNotFound.formats.large.url}`
            : ""
        }
        style={{
          border: "1px solid black",
          maxWidth: state.isMobile ? "85%" : "30%",
          maxHeight: "100%",
          width: "auto",
          height: "auto",
        }}
        alt="404 Page Not Found"
      />
    </div>
  );
}

export default NotFound;
